module.exports = __webpack_public_path__ + "media/images/logo-7bfe27e6.svg";